<template>
	<UserRegistrationFullScreenLayout class="temporary-verification-code">
		<div class="page-title">Verify that it’s you</div>
		<AppTextField outlined dense v-model="email" hide-details single-line placeholder="Enter email" class="mb-4" />
		<div class="page-description">Paste the verification code here.</div>
		<input
			type="text"
			ref="verificationCodeRef"
			class="verification-code-input"
			:class="{ 'is-focused': isFocused }"
			v-model="verificationCode"
			@focus="isFocused = true"
			@blur="isFocused = false"
			maxlength="6"
			placeholder="6-digit code"
			autofocus
		/>
		<v-btn :disabled="!email || !verificationCode" :loading="loading" color="primary" @click="login()">Login</v-btn>
		<div class="footer-text">Click <a :href="oneTimeTokenUrl" target="_blank">here</a> to get a new magic login code</div>
	</UserRegistrationFullScreenLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import UserRegistrationFullScreenLayout from './UserRegistrationFullScreenLayout.vue';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';

export default {
	name: 'TemporaryVerificationCodeInput',
	components: {
		UserRegistrationFullScreenLayout,
	},
	mixins: [UserRegistrationMixin],
	computed: {
		...mapGetters(['user']),
		...mapGetters('main', ['appURL']),

		oneTimeTokenUrl() {
			return this.appURL ? `${this.appURL}temporary-verification-code` : '';
		},
	},
	methods: {
		...mapActions(['verifyOneTimeToken']),
		async login() {
			this.loading = true;
			const res = await this.verifyOneTimeToken({ token: this.verificationCode, email: this.email }).finally(() => {
				this.loading = false;
			});
			if (!res) {
				console.log('failed to login with code');
			}
		},
	},
	data: () => ({
		loading: false,
		email: '',
		verificationCode: '',
		isFocused: true,
	}),
};
</script>

<style scoped lang="scss">
.temporary-verification-code {
	.verification-code-input {
		width: 235px;
		margin: 40px 0 0 0;
		padding: 15px 20px 15px 35px;
		letter-spacing: 20px;
		border-radius: 12px;
		box-shadow: 0 3px 10px 4px rgb(0 0 0 / 15%);
		color: #5c8df5;
		font-family: monospace;

		&:focus-visible {
			outline: none !important;
		}
		&.is-focused {
			box-shadow: 0 3px 10px 4px rgb(0 8 255 / 15%);
			transition: 0.3s;
		}
		&::placeholder {
			letter-spacing: 1px;
		}
	}

	.footer-text {
		margin: 20px 0 10px 0;
		font-size: 14px;
	}
}
</style>
